import { useDevice } from './useDevice';

export const useCanInstallIOSApp = () => {
  const { isIOSBrowser } = useDevice();

  return { canInstallIOSApp: isIOSBrowser };
};
